<div class="card-deck">
    <!-- <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                운행 대수
            </div>
            <div class="text-black-50 mt-1">
                <span>일평균</span>
                <span class="ml-2">
                    {{getAvgDriveCnt() | number}} 대
                </span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div class="w-100 d-flex justify-content-end align-items-baseline">
                <span class="h2 mb-0 font-weight-light">
                    {{getSumDriveCnt() | number}}
                </span>
                <span class="h5 mb-0 ml-1 text-black-50">
                    대
                </span>
            </div>
        </div>
    </div> -->

    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                운행 거리
            </div>
            <div class="text-black-50 mt-1">
                <span>일평균</span>
                <span class="ml-2">
                    {{(getAvgDist() * 0.001) | number:'0.0-1'}} km
                </span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div class="w-100 d-flex justify-content-end align-items-baseline">
                <span class="h2 mb-0 font-weight-light">
                    {{(getSumDist() * 0.001) | number:'0.0-1'}}
                </span>
                <span class="h5 mb-0 ml-1 text-black-50">
                    km
                </span>
            </div>
        </div>
    </div>

    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                운행 시간
            </div>
            <div class="text-black-50 mt-1">
                <span>일평균</span>
                <span class="ml-2">
                    {{getAvgDuration() | filterSecToTime}}
                </span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div class="w-100 d-flex justify-content-end align-items-baseline">
                <span class="h3 mb-0 font-weight-light">
                    {{getSumDuration() | filterSecToTime}}
                </span>
            </div>
        </div>
    </div>

    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                온도기록
            </div>
            <div class="text-black-50 mt-1">
                <span>온도1</span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div class="w-100 d-flex justify-content-end align-items-baseline">
                <span class="h2 mb-0 font-weight-light">
                    {{(getTemper1Min() * 0.1) | number:'0.0-1'}}
                </span>
                <span class="h5 mb-0 mx-1 text-black-50">
                    <i class="mdi mdi-tilde"></i>
                </span>
                <span class="h2 mb-0 font-weight-light">
                    {{(getTemper1Max() * 0.1) | number:'0.0-1'}}
                </span>
                <span class="h5 mb-0 ml-1 text-black-50">
                    <i class="mdi mdi-temperature-celsius"></i>
                </span>
            </div>
        </div>
    </div>

    <div class="card mb-0 border shadow-sm">
        <div class="card-header bg-white">
            <div class="h5 font-weight-normal mb-0">
                온도기록
            </div>
            <div class="text-black-50 mt-1">
                <span>온도2</span>
            </div>
        </div>
        <div class="card-body pt-0 pb-2 d-flex align-items-end">
            <div class="w-100 d-flex justify-content-end align-items-baseline">
                <span class="h2 mb-0 font-weight-light">
                    {{(getTemper2Min() * 0.1) | number:'0.0-1'}}
                </span>
                <span class="h5 mb-0 mx-1 text-black-50">
                    <i class="mdi mdi-tilde"></i>
                </span>
                <span class="h2 mb-0 font-weight-light">
                    {{(getTemper2Max() * 0.1) | number:'0.0-1'}}
                </span>
                <span class="h5 mb-0 ml-1 text-black-50">
                    <i class="mdi mdi-temperature-celsius"></i>
                </span>
            </div>
        </div>
    </div>
</div>
